import { getPageTypeFromDataLayer } from '@gumtree/shared/src/util/data-layer-service';
import { PricingMetadata } from './dtl-syi';

export const getPostAdPageType = (pricingMetadata: PricingMetadata): string =>
    `${getPageTypeFromDataLayer(window.dataLayer)}${
        pricingMetadata?.insertionPrice?.free === false ? 'Paid' : 'Free'
    }`;
